import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 21,
	viewBox: "0 0 15 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.5 0.5C3.32031 0.5 0 3.85938 0 8C0 11.0469 1.01562 11.9062 6.71875 20.1094C6.91406 20.3828 7.1875 20.5 7.5 20.5C7.77344 20.5 8.04688 20.3828 8.24219 20.1094C13.9453 11.9062 15 11.0469 15 8C15 3.85938 11.6406 0.5 7.5 0.5ZM7.5 17.9219C6.79688 16.9453 6.17188 16.0469 5.625 15.3047C2.22656 10.4609 1.875 9.83594 1.875 8C1.875 4.91406 4.375 2.375 7.5 2.375C10.5859 2.375 13.125 4.91406 13.125 8C13.125 9.83594 12.7344 10.4609 9.33594 15.3047C8.78906 16.0469 8.16406 16.9453 7.5 17.9219ZM10.3125 7.10156H8.39844V5.1875C8.39844 4.67969 8.00781 4.25 7.5 4.25C6.95312 4.25 6.5625 4.67969 6.5625 5.1875V7.10156H4.64844C4.14062 7.10156 3.75 7.49219 3.75 8C3.75 8.54688 4.14062 8.9375 4.64844 8.9375H6.5625V10.8516C6.5625 11.3594 6.95312 11.75 7.5 11.75C8.00781 11.75 8.39844 11.3594 8.39844 10.8516V8.9375H10.3125C10.8203 8.9375 11.25 8.54688 11.25 8C11.25 7.49219 10.8203 7.10156 10.3125 7.10156Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgLocationPlus);
export { ForwardRef as ReactComponent };
